/* src/app/components/header-desktop/header-desktop.component.scss */
:host {
  display: block;
}
.wrapper {
  height: 60px;
  padding-inline: 20px;
  background: var(--color-background-alt);
  border-bottom: 1px solid transparent;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: relative;
}
@media (max-width: 992px) {
  .wrapper {
    display: none;
  }
}
.venue {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  padding: 5px;
}
@media (max-width: 992px) {
  .venue {
    display: none;
  }
}
.venue h3 {
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.08em;
  text-align: left;
  margin-bottom: 2px;
}
@media (min-width: 991px) {
  .venue h3 {
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 0em;
    margin-bottom: 4px;
  }
}
.venue .change-location-block {
  display: flex;
  align-items: center;
  justify-content: center;
  position: 10px 0px;
}
.venue .change-location {
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.08em;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
  text-decoration-style: solid;
  text-underline-offset: 2px;
  cursor: pointer;
}
@media (min-width: 991px) {
  .venue .change-location {
    font-size: 14px;
    line-height: 16px;
  }
  .venue .change-location .location {
    display: inline-block;
    margin-right: 6px;
    height: 22px;
    width: 26px;
    vertical-align: middle;
  }
}
.logo {
  height: 25px;
  width: 130px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.action-block {
  display: flex;
  justify-content: center;
  align-items: center;
}
.action-block .btn {
  --background: var(--not-active-btn);
  min-height: 35px;
  min-width: 120px;
  --color: var(--color-black-alt);
  font-size: 12px;
  --border-width: 0px;
}
.action-block .btn:not(:last-child) {
  margin-right: 10px;
}
.venue_info_block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 14px 20px;
}
.venue_info_block .location {
  height: 14px;
  width: 18px;
}
@media (min-width: 991px) {
  .venue_info_block .location {
    display: none;
  }
}
@media (min-width: 991px) {
  .venue_info_block app-burger-btn {
    display: none;
  }
}
.venue_info_block h3 {
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.08em;
  text-align: center;
  margin-bottom: 2px;
}
@media (min-width: 991px) {
  .venue_info_block h3 {
    font-size: 28px;
    line-height: 28px;
    letter-spacing: 0em;
    margin-bottom: 4px;
  }
}
.show-basket {
  min-width: 200px;
  position: relative;
  min-height: 35px;
}
.show-basket ion-icon {
  margin-right: 10px;
}
@media (max-width: 992px) {
  .show-basket {
    display: none;
  }
}
.show-basket:hover {
  --background: var(--primary-btn) !important;
}
.show-basket h4 {
  color: white;
  font-size: 14px;
}
.wrapper-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px 5px 10px;
}
.wrapper-mobile .logo-icon {
  width: 100px;
  height: 30px;
}
/*# sourceMappingURL=header-desktop.component.css.map */
